import { environment } from "../../../../environments/environment";

export const PREFERENCES_LINK_PRIVACY_POLICY_KEY = 'privacy-policy';
export const PREFERENCES_LINK_TERMS_OF_USE_KEY = 'terms-of-use';

export const PREFERENCES_LINKS = [
    {
        key: PREFERENCES_LINK_PRIVACY_POLICY_KEY,
        name: 'Privacy&nbsp;Policy',
        url: `${environment.footerBaseUrl.withHeaderLink}privacy-policy`,
    },
    {
        key: PREFERENCES_LINK_TERMS_OF_USE_KEY,
        name: 'Terms&nbsp;of&nbsp;Use.',
        url: `${environment.footerBaseUrl.withHeaderLink}terms-of-use`,
    },
];

export const API_CCHS_URL = environment.env === 'prod'
  ? 'https://api.cchs.cloud/'
  : 'https://uat.api.cchs.cloud/';

export const PROFILE_CONSTANTS={
    MAILING_ADDRESS:'Mailing Address',
    PROPERTY_ADDRESS:'Property Address',
    INVALID_ADDRESS_LINE:'Please enter a valid address',
    INVALID_CITY:'Please enter a valid city',
    INVALID_STATE:'Please enter a valid state',
    ZIP_CODE_REQUIRED_MESSAGE: 'Please enter a valid Zip Code.',
    ZIP_CODE_INVALID_MESSAGE: 'Zip Code must have 5 digits 0-9.',
}
export const PHONE_VALUE_MOBILE_FROM_API = 'MOBILE';
export const PHONE_VALUE_HOME_FROM_API = 'HOME1';
export const PHONE_VALUE_OFFICE_FROM_API = 'OFFICE1';
export const PHONE_VALUE_MOBILE_LABEL = 'Mobile';

export const PHONE_TYPE_OPTIONS = [
  { label: 'Mobile (preferred)', value: PHONE_VALUE_MOBILE_FROM_API },
  { label: 'Home', value: PHONE_VALUE_HOME_FROM_API },
  { label: 'Office', value: PHONE_VALUE_OFFICE_FROM_API }
];

export const PREFERENCE_WAIT_MSG = 'Wait, while we update your preferences';
export const PREFERENCE_ERROR_MSG = 'Oops, something went wrong. Please try again or contact us for assistance.';
export const PREFERENCE_DONE_MSG = 'Thanks! Your preferences have been updated.';
export const PREFERENCE_MARKETING_QUE = "Would you like to receive calls and texts from Cinch Home Services about our offers and promotions, including via autodialers and/or artificial, AI-generated, or pre-recorded voice, at the number you provided? Consent isn't required to purchase.";
export const PREFERENCE_MARKETING_FREQ = 'Message frequency will vary. Message and data rates may apply. Reply HELP or STOP to cancel will be available. <br/> <br/>This does not affect calls or texts related to servicing your account, such as appointment reminders or service updates.';
export const CONTACT_INFO_PHONE_NUM_REQ = 'Add at least one phone number so we can reach if needed.';